import React from "react";
import ReactDOM from "react-dom";
import "./globals.css";
import "./styleguide.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("app"));
